import PropTypes from "prop-types"
import { useFooterContent } from "effects/useSiteContent"
import Container from "components/ui/Container"
import facebookIcon from "components/ui/Footer/facebook.svg"
import linkedinIcon from "components/ui/Footer/linkedin.svg"
import twitterIcon from "components/ui/Footer/twitter.svg"
import instagramIcon from "components/ui/Footer/instagram.svg"
import youtubeIcon from "components/ui/Footer/youtube.svg"

const NETWORK_META = {
  twitter: { icon: twitterIcon, label: "X" },
  linkedin: { icon: linkedinIcon, label: "LinkedIn" },
  instagram: { icon: instagramIcon, label: "Instagram" },
  facebook: { icon: facebookIcon, label: "Facebook" },
  youtube: { icon: youtubeIcon, label: "YouTube" },
}

function SocialLinks({ label, heading, description, networks }) {
  const { social } = useFooterContent()

  const entries = networks
    ? networks
        .map((key) => ({
          key,
          url: social?.[key]?.url,
          ...NETWORK_META[key],
        }))
        .filter((e) => e.url && e.icon)
    : Object.entries(NETWORK_META)
        .map(([key, meta]) => ({ key, url: social?.[key]?.url, ...meta }))
        .filter((e) => e.url)

  if (!entries.length) return null

  return (
    <Container section margin>
      <div className="flex flex-col gap-8 md:flex-row md:items-center md:gap-12">
        <div className="md:w-3/5">
          {label && (
            <p className="mb-2 text-sm font-semibold uppercase tracking-widest text-lush">
              {label}
            </p>
          )}
          {heading && (
            <h2 className="text-3xl font-bold text-gray-900">{heading}</h2>
          )}
          {description && (
            <p className="mt-3 text-base text-gray-600">{description}</p>
          )}
        </div>
        <div className="flex flex-wrap items-center gap-8 md:w-2/5 md:justify-end">
          {entries.map(({ key, url, icon, label: networkLabel }) => (
            <a
              key={key}
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              className="opacity-70 transition-opacity hover:opacity-100"
            >
              <img src={icon} alt={networkLabel} className="h-12 w-12" />
            </a>
          ))}
        </div>
      </div>
    </Container>
  )
}

SocialLinks.propTypes = {
  label: PropTypes.string,
  heading: PropTypes.string,
  description: PropTypes.string,
  /** Which networks to show, in order. Defaults to all available. */
  networks: PropTypes.arrayOf(PropTypes.string),
}

export default SocialLinks
